import { ComponentF } from "../ui";
import { withColor } from "../uiText";
export enum ALIGN_TYPE {
  left,
  center,
  right,
}
export enum VERT_TYPE {
  top,
  middle,
  bottom,
}
export const TextType: ComponentF<{
  title: string;
  align: ALIGN_TYPE;
  vert: VERT_TYPE;
  color?: string | null;
}> = (
  C,
  props = {
    color: null,
    title: "",
    align: ALIGN_TYPE.left,
    vert: VERT_TYPE.top,
  }
) => {
  let x, y;
  switch (props.align) {
    case ALIGN_TYPE.right:
      x = C.bounds.x + C.bounds.w - props.title.length;
      break;
    case ALIGN_TYPE.center:
      x = C.bounds.x + Math.floor((C.bounds.w - props.title.length) / 2);
      break;
    default:
      x = C.bounds.x;
  }
  switch (props.vert) {
    case VERT_TYPE.middle:
      y = C.bounds.y + Math.floor((C.bounds.h - 1) / 2);
      break;
    case VERT_TYPE.bottom:
      y = C.bounds.y + C.bounds.h - 1;
      break;
    default:
      y = C.bounds.y;
  }
  C.display.drawText(
    x,
    y,
    props.color ? withColor(props.color, props.title) : props.title,
    C.bounds.w
  );
};
